import { Injectable }     from '@angular/core';
import { CanActivate, Router }    from '@angular/router';
import { AuthService }    from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthService, public router: Router) {}

	canActivate() {
		if (this.authService.IsLoggedIn()) {
			return true;
		} else {
			this.router.navigate(['/login']);
			return false;
		}
	}
}

@Injectable()
export class InitGuard implements CanActivate {
	constructor(private authService: AuthService, public router: Router) {}

	canActivate() {
		return true;
	}
}
